export enum ProductActionType {
    ADD_PRODUCTS = "ADD_PRODUCTS",
    PRODUCTS_LOADING_ERROR = "PRODUCTS_LOADING_ERROR",
}
